import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteGLMKiloFlow from 'hooks/glmFlows/useDeleteGLMKiloFlow';
import { useStaffTracking } from 'hooks/mixpanel/useStaffTracking';
import { GLMKiloFlowList } from 'types';
import notificationHandler from 'utils/notifications';

const ModalDeleteGLMKiloFlow = ({
  opened,
  flow,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  flow: GLMKiloFlowList;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteGLMKiloFlow();
  const { trackGLMFlowDeleted } = useStaffTracking();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    mutate(flow.glmKiloFlowId, {
      onSuccess: () => {
        trackGLMFlowDeleted({
          flow_id: flow.glmKiloFlowId,
          direction: 'glm_to_kilo',
          trigger: flow.trigger,
          action: flow.action,
        });
        successNotification('Flow delete success', `${flow.glmKiloFlowId} successfully deleted.`);
      },
      onError: error => {
        errorNotification('Flow delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Flow</Title>}
      size='auto'
    >
      <Stack>
        <Text>{'Are you sure you want to delete this Flow?'}</Text>
        <Text color='dimmed'>
          This will also delete its execution history. This action cannot be undone.
        </Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalDeleteGLMKiloFlow;
